import React, { useEffect, useState } from 'react';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { PAGE_SIZE } from '../../../../_common/constant';
import { showDate } from '../../../../_common/functions';
import { AgGridReact } from 'ag-grid-react';
import Search from '../../../../components/search';
import Pagination from '../../../../components/pagination';

interface genProps {
  partDetails: any;
}
const PurchaseHistory: React.FC<genProps> = ({ partDetails }) => {
  const spearPartsAPI = useSpearPartsApi();
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState<string>('');

  const [rowData, setRowData] = useState<any>(null)

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };
  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSpearPartsList = () => {
    spearPartsAPI.stockCycleCountHistory({
      partsID: partDetails.partsID,
      pageSize: PAGE_SIZE,
      pageNumber: currentPage,
      searchParam: searchParam,
    }, (data: any) => {
      setTotalRecords(data.totalRecord);
      setRowData(data.cycleCountByPartList ? data.cycleCountByPartList : []);
    }, (error: any) => {
      setRowData([]);
    });
  };

  useEffect(() => {
    // getSpearPartsList();
  }, [currentPage, searchParam]);

  const columnDefs = [
    { headerName: 'Count Ref No', field: 'stockAdjustmentSerialNo', headerClass: 'bg-[#f0f0f0]', width: 130 },
    {
      headerName: 'Count Date', field: 'countingDate', headerClass: 'bg-[#f0f0f0]', width: 130,
      cellRenderer: (data: any) => data.value ? showDate(data.value) : '--'
    },
    { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', width: 170 },
    { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', width: 170 },
    { headerName: 'Expected Qty', field: 'systemQuantity', headerClass: 'bg-[#f0f0f0]', width: 130 },
    { headerName: 'Counted Qty', field: 'countedQuantity', headerClass: 'bg-[#f0f0f0]', width: 170 },
    { headerName: 'Counted By', field: 'countedByUserName', headerClass: 'bg-[#f0f0f0]', width: 170 },
    { headerName: 'Notes', field: 'cycleCountNotes', headerClass: 'bg-[#f0f0f0]', width: 170 },
  ];

  return (
    <div >
      <h1 className='pl-5 mt-5'>Purchase History Coming Soon...</h1>
      {/* <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
        <Pagination
          perPage={PAGE_SIZE}
          totalRecords={totalRecords}
          onPageChange={setCurrentPage}
          currentPage={currentPage}
        />
        <Search onSearch={setSearchParam} />
      </div>
      <div >
        <div className='bg-[#FAFAFA]'>

          <div className="ag-theme-alpine mx-4  h-1/2">
            <AgGridReact
              columnDefs={columnDefs} // Pass columnDefs
              rowData={rowData} // Pass rowData
              pagination={false}
              rowSelection="multiple"
              onGridReady={onGridReady}
              domLayout="autoHeight"
              onRowClicked={onRowClicked}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PurchaseHistory;